// extracted by css-extract-rspack-plugin
export default {"container":"container-PuBHGv","price":"price-ytxC18","ctaButton":"ctaButton-DyVLcY"};